export default "__VITE_ASSET__332b2ed2__"